import { Trans } from '@lingui/macro';
import React from 'react';

import AuthLayout from '@/UI/auth-layout';
import DownloadServerKeys from '@/components/DownloadServerKeys/DownloadServerKeys';

type Props = {};

const DownloadKeysPage = (props: Props) => {
    return (
        <AuthLayout header={<Trans>Download Encryption Keys</Trans>}>
            <DownloadServerKeys />
        </AuthLayout>
    );
};

export default DownloadKeysPage;
